export const FEATURED_BANNER = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.FeaturedBannerWidgetElement';
